import {fetchJson} from "../utils/SuperAgentFetch";
import ResponseStatusException from "../exceptions/ResponseStatusException";
import {config} from "../config/Config";
import {showError} from "../utils/NotificationsHelper";

export const WORKFLOW_LIST_REQUESTED = 'WORKFLOW_LIST_REQUESTED';
/**
 * Action for request of workflow list.
 *
 * @return {WorkflowListAction}
 */
export const requestWorkflowList = () => {
    return {
        type: WORKFLOW_LIST_REQUESTED
    };
};

export const WORKFLOW_LIST_RECEIVED = "WORKFLOW_LIST_RECEIVED";
/**
 *
 * @param {BaseEntryWithParent} workflowList
 * @return {ReceiveObjectListAction}
 */
export const receiveWorkflowList = (workflowList) => {
    return {
        type: WORKFLOW_LIST_RECEIVED,
        workflowList: workflowList,
        receivedAt: Date.now()
    }
};

export const WORKFLOW_LIST_ERROR = 'WORKFLOW_LIST_ERROR';
/**
 *
 * @param {Object} error
 * @param {String} type type of action
 * @param {Number} errorResponseStatusCode
 * @param {String} errorResponseMessage
 * @return {ReceiveWorflowListErrorAction}
 */
export const receiveError = (
    error,
    type = WORKFLOW_LIST_ERROR,
    errorResponseStatusCode = null,
    errorResponseMessage = null
) => {
    return {
        type: type,
        error: error,
        errorResponseStatusCode: errorResponseStatusCode,
        errorResponseMessage: errorResponseMessage,
    }
};


/**
 * Fetch workflow list
 *
 * @param {boolean} update if is a update request or new loading request
 * @return {function(*=, *): Promise<Object | never>}
 */
export const fetchWorkflowList = (update = false) => {
    return (dispatch, getState) => {
        if (update) {
            //dispatch(requestEntryDetailUpdate());
        } else {
            dispatch(requestWorkflowList());
        }

        /** @type RequestOptions options **/
        let options = {
            method: "GET"
        };
        options.ignore = {
            key: "fetchWorkflowList",
            maxLifeTime: 60000
        };
        options.cache = {
            key: "fetchWorkflowList",
            maxLifeTime: 60000,
            forceRefresh: false
        };

        return fetchJson(`${config.url.API_URL}/bpmn/process-definitions`, options, dispatch)
            .then(json => {
                    let res = [];
                    if (json._embedded && json._embedded.processDefinitions && json._embedded.processDefinitions.length > 0) {
                        res = json._embedded.processDefinitions;
                    }
                    dispatch(receiveWorkflowList(res));
                }
            ).catch(error => {
                if(error === "Ignoring request") {
                    // TODO create some better solution with ignoring same requests
                    // do nothing, is expected state
                } else if(error instanceof ResponseStatusException) {
                    const description = error.response.message ? error.response.message : null;
                    dispatch(receiveError(error, WORKFLOW_LIST_ERROR, error.response.status, description));
                    showError(dispatch, error.message, description);
                } else {
                    dispatch(receiveError(error, WORKFLOW_LIST_ERROR));
                    showError(dispatch, error.message);
                }
            });
    }
};